<div id="reportingDashboard" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="downloadReport()"></child-header>
    <div class="inner-subBlock-wrapper">

      <div id="basic-info-wrapper">
        <div style="margin-bottom: 20px;" class="row filter-wrapper">
          <div class="col searchInput-position">
            <div class="searchInputGroup">
              <div class="searchIcon">
                <img src="../../images/new_ui/filter.png">
              </div>
              <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                     onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
            </div>
          </div>
          <div class="col col-large">
            Term Expiry From:
            <div class="searchInputGroup">
              <div class="searchIcon" (click)="dateFrom.toggle()">
                <img src="../../images/new_ui/date.png">
              </div>
              <input id="dateFrom" class="searchInput date-picker" type="text" [(ngModel)]="fromDate" placeholder="Date"
                     mame="datePicker" ngbDatepicker #dateFrom="ngbDatepicker" (click)="dateFrom.toggle()">
            </div>
          </div>
          <div class="col col-large">
            To:
            <div class="searchInputGroup">
              <div class="searchIcon" (click)="dateTo.toggle()">
                <img src="../../images/new_ui/date.png">
              </div>
              <input id="dateTo" class="searchInput date-picker" type="text" [(ngModel)]="toDate" placeholder="Date"
                     mame="datePicker" ngbDatepicker #dateTo="ngbDatepicker" (click)="dateTo.toggle()">

            </div>
          </div>
          <div class="col col-small button-position">
            <button class="button button-red button-mid" id="btnFilter" (click)="filterRenewals();">Apply</button>
          </div>
        </div>
      </div>

      <div *ngIf="loadContent && upcomingRenewals.length > 0 && !hasEmptyFilterResult">
        <div class="shared-outer-wrapper table-header-allign" *ngIf="upcomingRenewals?.length">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead>
              <tr class="row">
                <th class="col" mat-sort-header="tenantName">TENANT NAME</th>
                <th class="col" mat-sort-header="sku">SKU</th>
                <th class="col" mat-sort-header="description">DESCRIPTION</th>
                <th class="col" style="max-width: 8%;" mat-sort-header="qty">QTY</th>
                <th class="col" style="max-width: 12%;" mat-sort-header="termStart">TERM START</th>
                <th class="col" style="max-width: 12%;" mat-sort-header="termExpiry">TERM EXPIRY</th>
                <th class="col" style="max-width: 11%;" ></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="shared-outer-wrapper child-body subscription-rp" *ngIf="upcomingRenewals?.length">
          <table matSort (matSortChange)="sortData($event)" class="white">
            <thead hidden="true">
              <tr class="row">
                <th class="col" mat-sort-header="tenantName">TENANT NAME</th>
                <th class="col" mat-sort-header="sku">SKU</th>
                <th class="col" mat-sort-header="description">DESCRIPTION</th>
                <th class="col" style="max-width: 8%;" mat-sort-header="qty">QTY</th>
                <th class="col" style="max-width: 12%;" mat-sort-header="termStart">TERM START</th>
                <th class="col" style="max-width: 12%;" mat-sort-header="termExpiry">TERM EXPIRY</th>
                <th class="col" style="max-width: 11%;" ></th>
              </tr>
            </thead>
            <tbody class="scrollable-table-body">
              <ng-container>
                <ng-container *ngFor="let renewal of sortedData | TableFilterMultiple:['out_tenant_name', 'out_stock_code', 'out_stk_description', 'out_qty', 'out_term_start_date', 'out_term_expiry_date'] : searchField">
                  <tr class="row">
                    <td class="col-md">{{renewal?.out_tenant_name}}</td>
                    <td class="col-md">{{renewal?.out_stock_code}}</td>
                    <td class="col-md" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" matTooltip="{{renewal?.out_stk_description}}">{{renewal?.out_stk_description}}</td>
                    <td class="col-md" style="max-width: 8%;">{{renewal?.out_qty}}</td>
                    <td class="col-md" style="max-width: 12%;">{{renewal?.out_term_start_date}}</td>
                    <td class="col-md" [ngClass]="{'expired-sub-date': pastExpiry(renewal?.out_term_expiry_date)}" style="max-width: 12%;">{{renewal?.out_term_expiry_date}}</td>
                    <td class="col-md" style="max-width: 11%;">
                      <button class="button button-red button-mid" (click)="showSubscription(renewal)">Manage</button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <ng-container *ngIf="loadContent && hasEmptyFilterResult">
        <div class="noResult-wrapper">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
          <button (click)="filterReset()" class="button button-red button-large">Try again</button>
          <div class="noResult-feedback">Send feedback</div>
        </div>
        <div class="top-divider"></div>
      </ng-container>

      <div class="inner-subBlock-wrapper" *ngIf="loadContent && !upcomingRenewals.length  && !hasEmptyFilterResult">
        <div class="noData-wrapper">
          <div>
            <img src="../../images/new_ui/no-subscription.png">
          </div>
          <label class="noData-label">
            WE COULDN'T FIND ANY <br/>
            INVOICES FOR GIVEN DATE RANGE
          </label>
          <br/>

        </div>
      </div>

    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
